import styled from "styled-components";
import {baseColors} from "../../../../themes/definitions/casino777/base-colors";
import {JackpotBetWidgetBgDefaultBox} from "./jackpot-bet-widget-bg.default.box";

export const JackpotBetWidgetBg777Box = styled(JackpotBetWidgetBgDefaultBox)`

    box-shadow: 0px 8px 8px 1px #00000038, 0px -1px 24px 8px #49968D80 inset;
    
    background-image: url(${props => props.theme.assets.images.jackpot_bet.jackpot_bet_mountains_bg_png.toString()}),
    linear-gradient(168.55deg, #8CD1BA 23.09%, ${baseColors.base02} 56.92%);
    
    background-blend-mode: darken;
    background-repeat: no-repeat, no-repeat;

    border: none;

    background-size: 190%;
    background-position-x: 41%;
    background-position-y: 290%;

    @media ${({theme}) => theme.mediaQuery.xxsAndBelow} {
        background-position-y: 240%;
    }

    @media ${({theme}) => theme.mediaQuery.sExact} {
        background-position-y: 100%;
    }

    @media ${({theme}) => theme.mediaQuery.mAndAbove + " and " + theme.mediaQuery.portrait} {            
        background-size: 230%;
        background-position-y: 195%;
    }

    @media ${({theme}) => theme.mediaQuery.xlAndAbove} {            
        background-size: 180%;
        background-position-y: 100%;
    }
`;
